import selectCountryCtor from './utils/selectCountryCtor';
import pwdFieldCtor from './utils/pwdFieldCtor';

import {
  MerchantSelect,
  MerchantInput,
  MerchantInputCode,
  MerchantDatepicker,
  MerchantTextarea,
  MerchantSwitch,
  MerchantUploadInput,
  MerchantRequestError
} from './merchant';

import {
  AuthInput,
  AuthCheckbox
} from './auth';

const AuthPwdInput = pwdFieldCtor(AuthInput);

const MerchantCountrySelect = selectCountryCtor(MerchantSelect);
const MerchantPwdInput = pwdFieldCtor(MerchantInput);

export {
  AuthInput,
  AuthPwdInput,
  AuthCheckbox,

  MerchantSelect,
  MerchantCountrySelect,
  MerchantInput,
  MerchantPwdInput,
  MerchantInputCode,
  MerchantDatepicker,
  MerchantTextarea,
  MerchantSwitch,
  MerchantRequestError,
  MerchantUploadInput
};
